import { ref } from 'vue'
import { initializePaddle } from '@paddle/paddle-js'
import { useRouter } from 'vue-router'

const getPublishableKey = () => {
  const key = process.env.VUE_APP_PADDLE_PUBLISHABLE_KEY

  return key || 'test_...'
}

const getEnvironment = () => {
  return process.env.VUE_APP_PADDLE_ENV === 'production' ? 'production' : 'sandbox'
}

const paddleInstance = ref(null)
const isReady = ref(false)

export function usePaddle() {
  const router = useRouter()

  const init = async() => {
    if (isReady.value) return

    try {
      paddleInstance.value = await initializePaddle({
        environment: getEnvironment(),
        token: getPublishableKey(),
        checkout: {
          settings: {
            displayMode: 'inline',
            frameTarget: 'checkout-container', // ID or class of your container
            frameInitialHeight: 416,
            frameStyle: 'width: 100%; min-width: 312px; background-color: transparent; border: none;'
          }
        },
        eventCallback: (data) => {
          if (data.name === 'checkout.completed') {
            router.push({ name: 'subscriptions-confirmation' })
          }
        }
      })
      isReady.value = true
    } catch (error) {
      console.error('Error initializing paddle:', error)
    }
  }

  const openCheckout = (transactionId) => {
    if (!isReady.value || !paddleInstance.value) {
      return
    }

    const checkoutPayload = {
      transactionId: transactionId
    }

    paddleInstance.value.Checkout.open(checkoutPayload)
  }
  const pricesPreview = async(items, discountId = null) => {
    if (!isReady.value || !paddleInstance.value) {
      return
    }

    const previewRequest = {
      items: items
    }

    if (discountId) {
      previewRequest.discountId = discountId
    }

    return paddleInstance.value.PricePreview(previewRequest)
  }

  return {
    init,
    openCheckout,
    pricesPreview,
    isReady
  }
}
